import * as QueryParamActions from '../actions/queryparams.action';
import {QueryParams} from '../interfaces/queryparams.interface';

export type Actions = QueryParamActions.Actions;

export function queryParamReducer(state: QueryParams, action: Actions) {
  switch (action.type) {
    case QueryParamActions.SET_QUERYPARAM:
      state = action.payload;
      return state;
    case QueryParamActions.DISMIS_QUERYPARAM:
      state = null;
      return state;
    default:
      return state;
  }
}
